var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.03312 6.22635C7.10752 6.30076 7.14472 6.38632 7.14472 6.48305C7.14472 6.57978 7.10752 6.66534 7.03312 6.73975L1.83222 11.9406C1.75782 12.015 1.67225 12.0522 1.57553 12.0522C1.4788 12.0522 1.39324 12.015 1.31883 11.9406L0.760795 11.3826C0.686391 11.3082 0.649188 11.2226 0.649188 11.1259C0.649188 11.0292 0.686391 10.9436 0.760795 10.8692L5.14696 6.48305L0.760795 2.09689C0.686391 2.02248 0.649188 1.93692 0.649188 1.84019C0.649188 1.74347 0.686391 1.6579 0.760795 1.5835L1.31883 1.02546C1.39324 0.951055 1.4788 0.913852 1.57553 0.913852C1.67225 0.913852 1.75782 0.951055 1.83222 1.02546L7.03312 6.22635Z",
    fill: "#2671D1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.1fc01b0fc49ee9f69be13f3d2fd75f60.svg";
export { ForwardRef as ReactComponent };